/**
 * Admin-visible invite status labels.
 * Canonical behavior: Send Invite and Copy Invite Link both create a NEW invite.
 * The previous pending invite is revoked server-side because the raw token is
 * never stored and cannot be reused.
 */

export const INVITE_STATUS = {
  NOT_SENT: 'not_sent',
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  EXPIRED: 'expired',
  REVOKED: 'revoked',
};

export function formatInviteStatus(status) {
  switch (status) {
    case INVITE_STATUS.PENDING:
      return 'Pending';
    case INVITE_STATUS.ACCEPTED:
      return 'Accepted';
    case INVITE_STATUS.EXPIRED:
      return 'Expired';
    case INVITE_STATUS.REVOKED:
    case INVITE_STATUS.NOT_SENT:
    default:
      return 'Not sent';
  }
}

export function formatInviteDate(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString();
}
